<template>
  <v-container fluid grid-list-md class="horizontal-padding-content">
    <v-row>
      <v-col order-lg="2" xl="4" lg="4" md="6" sm="12" xs="12" app>
        <v-flex d-flex xs12>
          <v-card
            v-if="$store?.getters.isLoggedIn"
            sticky
            fixed
            class="mx-auto rounded-card pa-5"
            min-width="90%"
            max-height="100%"
            elevation="3"
            outlined>
            <v-row justify="space-around">
              <v-avatar size="200">
                <v-img
                  v-if="record.taxRegime === 'PM'"
                  src="@/assets/images/pm.png"
                  alt="Empresa"
                />
                <v-img
                  v-else
                  src="@/assets/images/pfae.png"
                  alt="Persona"
                />
              </v-avatar>
            </v-row>
            <v-list-item three-line>
              <v-list-item-content class="txtc">
                <div class="overline mb-4">INFORMACIÓN DE LA EMPRESA</div>

                <!-- Selector de cliente -->
                <v-autocomplete
                  v-if="$store?.getters.user.isBluUser"
                  v-model="selectedClient"
                  :items="filteredClients"
                  item-text="entityName"
                  item-value="clientId"
                  label="Seleccionar cliente"
                  dense
                  outlined
                  hide-details
                  class="mb-4"
                  color="primary"
                  :search-input.sync="search"
                  no-filter
                  @change="onClientChange"
                >
                </v-autocomplete>

                <!-- Información del cliente actual -->
                <v-list-item-title
                  class="primary--text font-weight-black text-h5 mb-1 text-wrap"
                  :class="{ 'text-h6': $vuetify.breakpoint.xs || $vuetify.breakpoint.sm }"
                >
                  {{ record.entityName?.toUpperCase() }}
                </v-list-item-title>

                <v-list-item-title
                  class="primary--text font-weight-black text-uppercase"
                >
                  {{ record.rfc }}
                </v-list-item-title>

                <v-list-item-subtitle
                  class="primary--text"
                  v-if="record.taxRegime === 'PF'"
                >
                  Persona Física
                </v-list-item-subtitle>

                <v-list-item-subtitle
                  class="primary--text"
                  v-if="record.taxRegime === 'PFAE'"
                >
                  Persona Física con Actividad Empresarial
                </v-list-item-subtitle>

                <v-list-item-subtitle
                  class="primary--text"
                  v-if="record.taxRegime === 'PM'"
                >
                  Persona Moral
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item three-line>
              <v-list-item-content class="txtc">
                <v-btn
                    v-if="$store?.getters.user.isAdmin"
                    @click="addUser()"
                    class="mx-0 font-weight-bold "
                    :class="{'mx-4': !$store?.getters.user.isAdmin }"
                    color="primary"
                  >
                    <v-icon left>mdi-account-plus</v-icon>
                    Agregar Usuario
                </v-btn>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </v-flex>
      </v-col>
      <v-col order-lg="1" xl="8" lg="8" md="6" sm="12" xs="12">
        <v-expansion-panels popout v-if="$store?.getters.user.isAdmin" v-model="panel">
          <v-expansion-panel readonly>
            <v-expansion-panel-header>
              <h1 class="text-center primary--text font-weight-black">Lista de Usuarios</h1>
              <template v-slot:actions>
                <v-icon color="white"></v-icon>
              </template>
            </v-expansion-panel-header>
          </v-expansion-panel>
          <v-expansion-panel
            v-for="(user, key) of users" :key="key" :value="key"
            class="shake"
            transition="slide-x-transition"
            :disabled="disabled"
          >
            <v-expansion-panel-header>
              <template v-slot:default>
                <v-row no-gutters>
                  <v-col cols="8">
                    <h2 class="primary--text text-capitalize">
                        <v-icon color="#F57F17" v-if="user.isAdmin">mdi-account-star</v-icon>
                        <v-icon color="gray" v-if="!user.isAdmin && user.active">mdi-account</v-icon>
                        <v-icon color="#B71C1C" v-if="!user.isAdmin && !user.active">mdi-account-cancel</v-icon>
                        {{ user.firstName || user.email }}
                    </h2>
                  </v-col>
                  <v-col
                    cols="4"
                    class="text--secondary">
                    <v-fade-transition leave-absolute>
                      <span v-if="user.isAdmin"> Usuario Administrador</span>
                      <span v-if="!user.isAdmin && user.active"> Usuario activo</span>
                      <span v-if="!user.isAdmin && !user.active"> Usuario Deshabilitado</span>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content
              class="mb-0 pb-0"
              :key="key"
            >
              <User
                :adminsCount="adminsCount"
                :user="user"
                class="mb-0 pb-0"
                @removeUser="removeUser"
                @onDisabled="setDisabled"
                @onEnabled="setEnabled"
                @loadRecord="loadRecord"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <User
          :adminsCount="adminsCount"
          :user="$store?.getters.user"
          ref="usersComponent"
          @loadRecord="loadRecord"
          v-if="$store?.getters.isLoggedIn && !$store?.getters.user.isAdmin"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<!-- fill-height sticky fixed -->
<script>

import User from '@/components/Profile/User.vue'
import ClientService from '@/services/ClientService'
import ClientUserService from '@/services/ClientUserService'
import ClientBranch from '../common/ClientBranch'
import productMixin from '../mixins/productMixin'

export default {
  name: 'Profile',
  mixins: [productMixin],
  components: { User },
  data () {
    return {
      record: {},
      panel: undefined,
      disabled: false,
      users: [],
      clients: [],
      selectedClient: null,
      search: ''
    }
  },
  beforeCreate () {
    if (!this.$store?.getters.isLoggedIn) {
      const routeData = this.$router.resolve({ name: 'login' })
      window.open(routeData.href, '_self')
    }
  },
  mounted () {
    if (this.$store?.getters.isLoggedIn) {
      this.loadRecord()
    }
  },
  methods: {
    setEnabled () {
      this.disabled = false
    },
    setDisabled () {
      this.disabled = true
    },
    async loadRecord () {
      const loader = this.$loading.show()
      const clientRFC = this.$store?.getters?.user?.client?.rfc
      try {
        const { users, ...record } = await ClientService.getClientByRFC(clientRFC)
        this.record = record
        this.setUsers(users)

        // Si es un ejecutivo, cargar todos los clientes por si se quiere cambiar de cliente
        if (this.$store?.getters?.user?.isBluUser) {
          const { items: clients } = await ClientService.getAllClients({ branch: [ClientBranch.BLUE, ClientBranch.GREEN, ClientBranch.EXIT] })
          this.clients = clients
        }

        loader.hide()
      } catch (error) {
        loader.hide()
        console.error(error)
      }
    },
    addUser () {
      const index = this.users.findIndex(user => !user.userId)
      if (index === 0) {
        this.showErrorMessage('SAVE_FIRST')
        this.panel = 1
        return
      }

      const user = {
        clientId: this.record.clientId,
        active: true,
        notifications: { }
      }
      this.users.unshift(user)
      this.panel = 1
    },
    removeUser (key) {
      this.users.splice(key, 1)
      this.panel = undefined
    },
    showErrorMessage (message) {
      this.$swal({
        title: '¡Error!',
        html: this.$t(message),
        icon: 'error',
        showCancelButton: false,
        confirmButtonText: 'Ok',
        confirmButtonColor: '#1374F2',
        showCloseButton: true,
        allowOutsideClick: false
      })
    },
    setUsers (users) {
      // Mostrar solo usuarios que no sean ejecutivos blu
      this.users = users.filter(cu => !cu.isBluUser)
    },
    async onClientChange () {
      if (!this.selectedClient) return
      const loader = this.$loading.show()
      try {
        const { users, ...selected } = this.clients.find(c => c.clientId === this.selectedClient)

        this.selectedClient = null
        this.search = ''
        this.record = selected
        this.setUsers(users)

        await ClientUserService.update({
          ...this.$store?.getters?.user,
          clientId: selected.clientId,
          client: selected
        })

        await this.$store?.dispatch('setUser', {
          user: {
            ...this.$store?.getters?.user,
            clientId: selected.clientId,
            client: selected
          },
          isLoggedIn: true
        })

        await this.setClientPortafolio(selected.clientId)
      } catch (error) {
        console.error(error)

        this.$swal({
          title: 'Error al cambiar de cliente',
          html: error?.message || 'Ocurrió un problema al actualizar la información. Intenta de nuevo.',
          icon: 'error'
        })
      } finally {
        loader.hide()
      }
    },
    normalizeText (text = '') {
      return text
        .toLowerCase()
        .normalize('NFD') // separa letras y acentos
        .replace(/[\u0300-\u036f]/g, '') // elimina acentos
        .replace(/\s+/g, ' ') // colapsa espacios múltiples
        .trim()
    }
  },
  computed: {
    adminsCount () {
      return (this.users || []).filter(cu => cu.isAdmin && !cu.isBluUser).length
    },
    filteredClients () {
      if (!this.search || this.search.length < 2) return []

      const query = this.normalizeText(this.search)

      return this.clients.filter(c => {
        const name = this.normalizeText(c.entityName)
        return (name.includes(query) && c.clientId !== this.record.clientId)
      }).map(c => { return { ...c, entityName: c.entityName?.toUpperCase() } })
    }
  }
}
</script>
<style scoped>
  .rounded-card { border-radius:30px !important; }
  .txtc {
    text-align: center!important;
  }
  .overline {
    font-size: 0.725rem !important;
  }
  .shake {
    -webkit-animation-name: shake!important;
    animation-name: shake!important;
  }
</style>
